import { render, staticRenderFns } from "./create_work_item.vue.js?vue&type=template&id=8fa450b0!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./create_work_item.vue?vue&type=template&id=8fa450b0"
import script from "./create_work_item.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./create_work_item.vue?vue&type=script&lang=js"
export * from "./create_work_item.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./create_work_item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports